import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getBrowserPreferences, setBrowserPreferences } from 'utils/browser';
import fetchLogoutAction from './modules/actions';

function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    const pushToken = getBrowserPreferences('pushToken');
    if (pushToken) {
      setBrowserPreferences('pushToken', 'logout');
    }
    dispatch(fetchLogoutAction({ pushToken }));
  }, [dispatch]);

  return null;
}

export default Logout;
